import { useRef, useEffect } from 'react';

/**
 * This is the same as React.useEffect, except it will not call `effect` after
 * the initial render. This is equivalent to `componentDidUpdate`.
 *
 * @param effect Imperative function that can return a cleanup function
 * @param deps Effect will only activate if the values in the list change
 */
var useEffectOnUpdate = function (effect, deps) {
    var didSkipFirstCallbackRef = useRef(false);
    useEffect(function () {
        if (didSkipFirstCallbackRef.current) {
            return effect();
        }
        // Skipped effect on first render, mark that we have done so
        didSkipFirstCallbackRef.current = true;
    }, deps);
};

export { useEffectOnUpdate };
